import { ThreeDots } from "react-loader-spinner";

import { Card } from "../../../shared/card/card.tsx";
import { EmptyStateMessage } from "../../../shared/empty-state-message/empty-state-message.tsx";
import { Avatar, ResponsiveDataTable, type ResponsiveColumn } from "../../../ui/index.ts";
import type { UtilizationRow } from "../types.ts";
import { formatDecimalHoursToHoursAndMinutes } from "../../../../utils/helpers.ts";
import styles from "./utilization-report-components.module.css";

const COLUMNS: ResponsiveColumn<UtilizationRow>[] = [
  {
    id: "employeeName",
    header: "Employee Name",
    accessor: "employeeName",
    sortable: true,
    render: (row) => (
      <div className={styles.employeeCell}>
        <Avatar
          name={row.employeeName}
          src={row.photoPath || undefined}
          size="md"
        />
        <div className={styles.employeeDetails}>
          <span className="body-sm">{row.employeeName}</span>
          <span className={styles.employeeDepartment}>{row.department}</span>
        </div>
      </div>
    ),
  },
    {
    id: "allocatedHours",
    header: "Allocated Tiime",
    accessor: "allocatedHours",
    sortable: true,
    render: (row) =>
      formatDecimalHoursToHoursAndMinutes(row.allocatedHours),
  },
  {
    id: "remainingHours",
    header: "Remaining Time",
    accessor: "remainingHours",
    sortable: true,
    render: (row) =>
      formatDecimalHoursToHoursAndMinutes(row.remainingHours),
  },

];

export function UtilizationReportTable({
  rows,
  loading,
  page,
  pageSize,
  totalItems,
  onPageChange,
  onPageSizeChange,
}: {
  rows: UtilizationRow[];
  loading: boolean;
  page: number;
  pageSize: number;
  totalItems: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
}) {
  return (
    <Card padding="none" className={styles.tableCard}>
      {loading ? (
        <div className={styles.loadingWrap} aria-label="Loading utilization report">
          <ThreeDots height="48" width="48" color="var(--info)" visible />
        </div>
      ) : (
        <ResponsiveDataTable<UtilizationRow>
          columns={COLUMNS}
          data={rows}
          aria-label="Utilization report"
          emptyState={<EmptyStateMessage message="No records available" />}
          pagination
          page={page}
          pageSize={pageSize}
          totalItems={totalItems}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
          pageSizeOptions={[5, 10, 20, 30, 40]}
        />
      )}
    </Card>
  );
}
